// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subtitleText__fbagr {
  font-size: 18px;
  line-height: 20px;
}

.confirmUser__HuGdQ {
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  margin-top: 30px;
  padding: 10px 15px;
  border-radius: 5px;
  border: 1px solid var(--inputs-filled-stroke);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.confirmUserName__uGutW {
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
}

.confirmUserEmail__yKBpo {
  color: var(--tables-primary-row-text-additional);
  text-transform: lowercase;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.userStepsResendBtn__hJnFp {
  color: var(--buttons-surface);
  padding-bottom: 5px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/UserModal/components/ResendEmailBtn/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,iDAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAzEF;;AA4EA;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,gDAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,6BAAA;EACA,mBAAA;EACA,eAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.subtitleText {\n  font-size: 18px;\n  line-height: 20px;\n}\n\n.confirmUser {\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  margin-top: 30px;\n  padding: 10px 15px;\n  border-radius: 5px;\n  border: 1px solid var(--inputs-filled-stroke);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n}\n\n.confirmUserName {\n  color: var(--tables-primary-row-text-main);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.confirmUserEmail {\n  color: var(--tables-primary-row-text-additional);\n  text-transform: lowercase;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.userStepsResendBtn {\n  color: var(--buttons-surface);\n  padding-bottom: 5px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtitleText": `subtitleText__fbagr`,
	"confirmUser": `confirmUser__HuGdQ`,
	"confirmUserName": `confirmUserName__uGutW`,
	"confirmUserEmail": `confirmUserEmail__yKBpo`,
	"userStepsResendBtn": `userStepsResendBtn__hJnFp`
};
module.exports = ___CSS_LOADER_EXPORT___;
